var uiBreakdown = {
	table: {
		caption: "Breakdowns",
		weight: "Weight %",
		name: "Name",
		noItems: "No results found"
	},
	chart: {
		counting: "Breakdowns",
		topPositions: "Top positions",
		others: "Others"
	}
};
var en = {
	uiBreakdown: uiBreakdown
};

export { en as default, uiBreakdown };
